import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-100 font-weight-bold" }

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'InfoSwitch',
  props: {
    value: { type: Boolean },
    size: { default: "sm" },
    title: {},
    disabled: { type: Boolean, default: false }
  },
  emits: ["input"],
  setup(__props: any, { emit: emits }) {

const props = __props;





const localValue = computed({
  get() {
    return props.value;
  },
  set(nv) {
    emits("input", nv);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_b_checkbox = _resolveComponent("b-checkbox")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.size == 'sm' ? `info-switch-sm` : `info-switch`)
  }, [
    _createElementVNode("label", _hoisted_1, _toDisplayString(_ctx.title), 1),
    _createVNode(_component_b_checkbox, {
      modelValue: localValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localValue).value = $event)),
      switch: "",
      disabled: _ctx.disabled,
      "data-cy": "info-switch-chx"
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createTextVNode(_toDisplayString(localValue.value ? _ctx.$t("on") : _ctx.$t("off")), 1)
        ])
      ]),
      _: 3
    }, 8, ["modelValue", "disabled"])
  ], 2))
}
}

})